/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-16 18:16:45
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-09 15:06:42
 * @FilePath: /unifyxp-v2-store-portal/src/components/EditableTable/TableSelect/TableSelect.tsx
 */
import React from 'react';
import css from './css.less';
import Select from '@/src/components/Antd/Select/Select';

const TableInput = (props) => {
  const [_focus, _setFocus] = React.useState(false);
  const { value, error, label, disabled, ...rest } = props;
  const onFocus = (e) => {
    e.stopPropagation();
    _setFocus(true);
  };
  const onBlur = () => {
    _setFocus(false);
  };
  React.useEffect(() => {
    document.addEventListener('click', onBlur);
    return () => {
      document.removeEventListener('click', onBlur);
    };
  }, []);
  React.useEffect(() => {
    if (error) {
      _setFocus(true);
    }
  }, [error]);

  const _editting = !disabled && (_focus || error);
  return (
    <div className={css.container} onClick={onFocus}>
      {_editting ? (
        <Select
          onBlur={onBlur}
          error={error}
          value={value}
          {...rest}
          //getPopupContainer={() => document.body}
        />
      ) : (
        <>
          {label || value ? (
            <div className={css.label}>{label || value}</div>
          ) : (
            <div className={css.placeholder}>{'Select Value'}</div>
          )}
        </>
      )}
    </div>
  );
};
export default TableInput;
